import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Images } from "lucide-react";
import { useLang } from "@/i18n";

export const GalleriaPreview = () => {
  const { t } = useLang();
  return (
    <section className="relative py-24 sm:py-32" data-testid="galleria-preview-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <span className="inline-flex items-center gap-2 font-mono-ed text-xs uppercase tracking-[0.22em] text-[#0284C7]">
              <Images size={14} /> {t.preview.label}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#0B2530] mt-4 leading-tight">
              {t.preview.h2a}<em className="font-serif-ed italic font-medium text-[#06B6D4]">{t.preview.h2em}</em>
            </h2>
            <p className="text-[#3D5A66] mt-6 text-base sm:text-lg leading-relaxed">
              {t.preview.text}
            </p>
            <Link to="/galleria" data-testid="galleria-preview-cta"
              className="group inline-flex items-center gap-2 mt-8 rounded-full bg-[#0B2530] text-white font-semibold px-7 py-3.5 hover:bg-[#0284C7] transition-colors duration-300 active:scale-95">
              {t.preview.cta}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-3 gap-4 sm:gap-5">
            {[
              { src: "/images/yuma-office.webp", alt: "La sede di YUMA Coop", cls: "col-span-2 h-52 sm:h-64", d: 0 },
              { src: "/images/arbitro-figc.webp", alt: "Yuri arbitro FIGC della sezione di Alessandria", cls: "h-52 sm:h-64 object-top", d: 0.12 },
              { src: "/images/yuri-portrait.jpg", alt: "Un momento informale", cls: "h-44 sm:h-56 object-top", d: 0.2 },
              { src: "/images/soluzione-albania-team.webp", alt: "Yuri con il team di medici e infermieri in Albania", cls: "col-span-2 h-44 sm:h-56", d: 0.28 },
            ].map((im) => (
              <motion.div
                key={im.src + im.alt}
                initial={{ opacity: 0, y: 40, scale: 0.96 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: im.d, ease: [0.22, 1, 0.36, 1] }}
                className={`rounded-2xl overflow-hidden img-frame ${im.cls.split(" ").filter((c) => c.startsWith("col-")).join(" ")}`}
              >
                <img src={im.src} alt={im.alt} loading="lazy"
                  className={`w-full object-cover hover:scale-105 transition-transform duration-700 ${im.cls.split(" ").filter((c) => !c.startsWith("col-")).join(" ")}`} />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
